<div class="container main-content">
  <div class="page-header">
    <h2>Welcome to Renewals!</h2>
    <span class="flex-fill"></span>
    <span class="space-fill"></span>
  </div>
  <h3>Please select the type of renewal you want to do:</h3>

  <div class="flex-container" *ngIf="originalQuoteRequestId">
    <div class="flex-item">
      <a (click)="navigateTo('custom')">
        <i class="fa-kit fa-solid-wrench-circle-dollar fa-2xl"></i>
        <p>Custom</p>
      </a>
    </div>

    <div class="flex-item">
      <a (click)="navigateTo('matrix')">
        <i class="fa-kit fa-solid-grid-circle-dollar fa-2xl"></i>
        <p>Matrix</p>
      </a>
    </div>
  </div>
</div>
